import React from 'react';
import PropTypes from 'prop-types';

export const EmptyMessage = ({ color, children, style }) => {
  const fixedStyle = {
    color: color || '#ccc',
    textAlign: 'center',
    fontStyle: 'italic',
  };

  return <div style={{ ...style, ...fixedStyle }}>{children}</div>;
};

export const AddableEmptyMessage = () => (
  <div style={{ textAlign: 'center', color: '#999', fontSize: 12 }}>
    <i>- Nessun elemento presente -</i>
  </div>
);

EmptyMessage.propTypes = {
  children: PropTypes.string,
  color: PropTypes.string,
  style: PropTypes.object,
};
EmptyMessage.defaultProps = {
  style: {},
};

export default EmptyMessage;



// WEBPACK FOOTER //
// ./app/components/Forms/UI/EmptyMessage/index.js